import { jsx as _jsx } from "react/jsx-runtime";
import { useBreakpointValue } from '@chakra-ui/react';
import { PaginationFull } from './PaginationFull';
import { PaginationMinimal } from './PaginationMinimal';
export const Pagination = ({ variant: variantProp = 'full', ssr, ...props }) => {
    const variant = useBreakpointValue(typeof variantProp === 'string' ? { base: variantProp } : variantProp, { ssr });
    return variant === 'minimal' ? (_jsx(Pagination.Minimal, { ...props })) : (_jsx(Pagination.Full, { ...props }));
};
Pagination.Full = PaginationFull;
Pagination.Minimal = PaginationMinimal;
Pagination.Full.displayName = 'Pagination.Full';
Pagination.Minimal.displayName = 'Pagination.Minimal';
